import React from "react";
import {changeLanguage} from "../../components/I18N/TranslateHelpers";
import {GetCurrentLocale} from "../../components/Utils";
import {countSelectedSubTaxon, handleCheckedFilters, pushItemsInSelectedFilters} from "../../components/UtilsForCart";
import {Filter} from "../Entity/Filter";

interface ComponentProps {
  setGroupCode: React.Dispatch<React.SetStateAction<string>>,
  setTaxonomiesSelected: React.Dispatch<React.SetStateAction<string[]>>,
  filtersSelectedParent: string,
  taxonomiesSelected: string[],
  filters: Filter[] | null,
  subTaxonsParent: Filter,
  arraySubTaxonsCounter: {parentCode: string; taxonsCodes: string[]; count: number; }[],
  setArraySubTaxonsCounter: React.Dispatch<React.SetStateAction<{parentCode: string; taxonsCodes: string[]; count: number}[]>>,
  allSubTaxonomiesSelected: Filter[],
  filtersSelected: any,
  history: any
}
const SubTaxonomiesProducts: React.FC<ComponentProps> = ({setGroupCode,
                                                           setTaxonomiesSelected,
                                                           taxonomiesSelected,
                                                           filters,
                                                           subTaxonsParent,
                                                           arraySubTaxonsCounter,
                                                           setArraySubTaxonsCounter,
                                                           allSubTaxonomiesSelected,
                                                           filtersSelected,
                                                           history
}:ComponentProps) => {
  const locale = GetCurrentLocale();
  changeLanguage(locale)

  return (
    allSubTaxonomiesSelected.length > 0 ?
      <ul className="subcategories d-flex justify-content-start mb-0 py-2 flex-wrap border-top">
        <li key={subTaxonsParent.label}>
          <label className="checkbox-btn">
            <input
              type="checkbox"
              checked={taxonomiesSelected.includes(subTaxonsParent.code)}
              onChange={(e) => handleCheckedFilters(subTaxonsParent, taxonomiesSelected, setTaxonomiesSelected, setGroupCode)}
            />
            <span className="btn btn-light fontsize12">{ subTaxonsParent.label }</span>
          </label>
        </li>
        {
          allSubTaxonomiesSelected && allSubTaxonomiesSelected.map((subTaxonItem: Filter) => {
            return(
              <li key={subTaxonItem.label}>
                <label className="checkbox-btn">
                  <input
                    type="checkbox"
                    checked={taxonomiesSelected.includes(subTaxonItem.code)}
                    onChange={() => {
                      setTaxonomiesSelected(prev => {
                        const set = new Set(prev);
                        if (set.has(subTaxonItem.code)) set.delete(subTaxonItem.code);
                        else set.add(subTaxonItem.code);
                        if (!set.has(subTaxonsParent.code)) set.add(subTaxonsParent.code);

                        return Array.from(set);
                      });

                      setGroupCode(subTaxonsParent.groupCode ?? "");

                      countSelectedSubTaxon(subTaxonItem, arraySubTaxonsCounter, setArraySubTaxonsCounter);
                    }}
                  />
                  <span className="btn btn-light fontsize12">{ subTaxonItem.label }</span>
                </label>
              </li>
            )
          })
        }
      </ul>
      :
      null
  )
}
export default SubTaxonomiesProducts;
